import Chart from 'chart.js/auto'
import { colors, lineChartOptions, formatDateLabel, reduceLabels } from './chart_config'

export function buildSessionsChart(canvas, data) {
  const formattedLabels = reduceLabels(data.labels)

  return new Chart(canvas, {
    type: 'line',
    data: {
      labels: formattedLabels.length ? formattedLabels : data.labels.map(formatDateLabel),
      datasets: [{
        label: 'Active Sessions',
        data: data.data,
        borderColor: colors.purple[500],
        backgroundColor: colors.purpleAlpha[10],
        fill: true
      }]
    },
    options: {
      ...lineChartOptions,
      plugins: {
        ...lineChartOptions.plugins,
        tooltip: {
          ...lineChartOptions.plugins.tooltip,
          callbacks: {
            title: (items) => {
              const idx = items[0].dataIndex
              return formatDateLabel(data.labels[idx])
            },
            label: (item) => `${item.raw} active session${item.raw !== 1 ? 's' : ''}`
          }
        }
      }
    }
  })
}
